export const AppUser = {
    roles : {
        SITE_MANAGER : 1,
        SUB_CONTRACTOR : 2,
        VISITOR : 3,
        LEAD_ADMIN : 4,
        SYSTEM_ADMIN : 5
    }
}